import {
  doc,
  collection,
  getDoc,
  getDocs,
  query,
  where,
  documentId,
  type DocumentData,
  type DocumentReference,
  type DocumentSnapshot,
  addDoc,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../../config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const inputsRef = collection(db, 'inputs');
const inputDocument = (id: string): DocumentReference<DocumentData> => doc(inputsRef, id);
const inputSnapshot = async (id: string): Promise<DocumentSnapshot> =>
  await getDoc(inputDocument(id));

// inputレコードをidで取得する
export const getInput = async (id: string): Promise<DocumentData | undefined> => {
  const input = await inputSnapshot(id);
  return input.data();
};

// inputレコードを複数IDで一括取得する（Firestoreのin句は最大10件なのでチャンク分割）
export const getInputsByIds = async (ids: string[]): Promise<Record<string, DocumentData>> => {
  const uniqueIds = Array.from(new Set(ids.filter(id => !!id)));
  if (uniqueIds.length === 0) return {};

  const inputMap: Record<string, DocumentData> = {};

  for (let i = 0; i < uniqueIds.length; i += 10) {
    const chunk = uniqueIds.slice(i, i + 10);
    const q = query(inputsRef, where(documentId(), 'in', chunk));
    const snapshot = await getDocs(q);
    snapshot.docs.forEach(docSnap => {
      inputMap[docSnap.id] = docSnap.data();
    });
  }

  return inputMap;
};

// inputレコードを作成する
export const postInput = async (data: DocumentData): Promise<DocumentReference<DocumentData>> => {
  return await addDoc(inputsRef, data);
};

// inputレコードを更新する
export const putInput = async (id: string, data: DocumentData): Promise<void> => {
  await updateDoc(inputDocument(id), data);
};
